<template>
  <v-container fill-height fluid class="d-table-fixed pa-0">
    <div class="d-table-header-group">
      <v-card class="mb-2">
        <v-row class="ma-0 py-1 pl-1">
          <v-col cols="auto" class="pa-0">
            <v-btn
                icon
                color="primary"
                @click="$router.push({name: 'dashboard', params: { reload: search ? false : true } })">
              <v-icon size="30">mdi-arrow-left-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col class="pa-0 pl-1" style="padding-top: 0.1rem !important;">
            <v-row class="ma-0" dense>
              <v-col class="d-flex align-center pa-0">
                <span class="text-h5 font-weight-black">
                  {{ pratica.documentNbr }}
                </span>
              </v-col>
              <v-col class="d-flex align-center pa-0">
                <span class="text-h5 primary--text font-weight-black">
                  {{ matchedPartyName }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-card
        width="100%"
        v-if="internalVisibilityAuth === true"
        class="d-table-fixed fill-height"
    >
      <v-tabs
          v-model="tab"
          class="d-table-header-group"
          background-color="accent"
          height="2rem"
          fixed-tabs
      >
        <v-tab>{{ $t('label.info') }}</v-tab>
        <v-tab>{{ $t('label.documents') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="display: table-row !important;">
        <v-tab-item class="pa-2">
          <ETPraticaTrasportoPrincipaleMare
              v-if="pratica && pratica.id"
              :pratica="pratica"
              :imballi="imballi"
              :praticaActions="praticaActions"
              :company="company"
          />
        </v-tab-item>
        <v-tab-item class="pa-2">
          <ETPraticaDocuments
              :pratica="pratica"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import {mapState} from 'vuex'
import {dateFilter} from '@/filters/dateFilter'
import {praticheService} from '@/services/pratiche.service.js'
import {imballiService} from '@/services/imballi.service.js'
import ETPraticaTrasportoPrincipaleMare from "./ETPraticaTrasportoPrincipaleMare";
import {suppliersService} from "../../../../services/suppliers.service";
import ETPraticaDocuments from "./ETPraticaDocuments";


export default {
  name: 'ETPraticaPage',
  props: ['id'],
  components: {
    ETPraticaDocuments,
    ETPraticaTrasportoPrincipaleMare,
  },
  data() {
    return {
      tab: null,

      pratica: {},
      company: {},
      imballi: [],
      praticaActions: {},

      message: '',
      snackbar: false,
      isSuccess: true,
    }
  },
  computed: {
    ...mapState('account', ['user', 'userAuthorizations', 'internalVisibilityAuth']),
    ...mapState('searchbar', ['search']),
    matchedPartyName() {
      const checks = [
        {
          list: this.user.shippers,
          target: this.pratica.shipper,
          field: 'customerName'
        },
        {
          list: this.user.consignees,
          target: this.pratica.consignee,
          field: 'customerName'
        },
        {
          list: this.user.customers,
          target: this.pratica.client,
          field: 'customerName'
        },
        {
          list: this.user.clientsTo,
          target: this.pratica.secondClient,
          field: 'customerName'
        },
        {
          list: this.user.foreignAgents,
          target: this.pratica.foreignAgent,
          field: 'supplierName'
        }
      ]

      for (const check of checks) {
        const match = check.list?.find(
            item => item.id === check.target?.id
        )

        if (match) {
          return match[check.field]
        }
      }

      return null
    }
  },
  methods: {
    init() {
      this.loadPratica()
    },
    loadPratica() {
      praticheService.getPraticaById(this.id).then((resp) => {
        if (!resp) return
        this.pratica = resp
        this.loadImballiForPratica()
        this.getCompany()
      })
    },
    loadImballiForPratica() {
      imballiService
          .getImballiByDocumentNbr(this.pratica.documentNbr, this.pratica.tenantId)
          .then((resp) => {
            if (resp) this.imballi = resp
          })
    },
    formatDate(value) {
      return dateFilter.formatDateDay(value)
    },
    getCompany() {
      if (!this.pratica.mainTransportCompany || !this.pratica.mainTransportCompany.length)
        return
      suppliersService
          .getSupplierBySupplierId(this.pratica.mainTransportCompany, this.pratica.tenantId)
          .then((resp) => {
            if (resp) this.company = resp
          })
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped>
.v-tabs-items {
  display: grid !important;
}

.v-tabs-items::v-deep .v-window__container {
  height: 100%;
}

.v-tabs-items::v-deep .v-window-item {
  height: 100%;
}

.v-application .text-overline {
  line-height: 0 !important;
}

</style>
